Ext.define('SA.VectorMapExportThematicMap', {
    alias: 'widget.vector-map-export-thematic-map',
    extend: 'SA.VectorMapExportScalingContainer',

    item: {
        xtype: 'component',
        cls: 'sa-vector-map-export-thematic-map-item',
        html: '<div class="sa-vector-map-export-thematic-map-container"></div>',
        width: 800
    },

    statics: {
        async getCanvas({attributionText, geoJsonSourcesData, layersProperties, maxExtent, style, styleBaseUrls, tileSourcesUrls, params}) {
            var el = SA.HiddenDom.attach(SA.Html.create({type: 'div'})),
                map = Ext.widget({
                    xtype: 'vector-map-export-thematic-map',
                    attributionText,
                    geoJsonSourcesData,
                    layersProperties,
                    maxExtent,
                    renderTo: el,
                    style,
                    styleBaseUrls,
                    tileSourcesUrls
                }),
                canvasRenderer = new SA.CanvasRenderer(),
                attribution, mapCanvas;

            map.setParams(params);

            await new Promise(resolve => map.map.once('idle', resolve));

            attribution = await SA.Svg.toImageElement(map.attribution);
            mapCanvas = map.map.getCanvas();

            canvasRenderer.render({
                height: mapCanvas.height,
                width: mapCanvas.width,

                content: [
                    {
                        type: 'image',
                        source: mapCanvas
                    }, {
                        type: 'image',
                        height: attribution.height * map.getScale(),
                        source: attribution,
                        width: attribution.width * map.getScale(),
                        x: mapCanvas.width - attribution.width * map.getScale(),
                        y: mapCanvas.height - attribution.height * map.getScale()
                    }
                ]
            });

            map.destroy();
            el.remove();

            return canvasRenderer.getCanvas();
        }
    },

    afterRender() {
        var {attributionText = '', geoJsonSourcesData, layersProperties, maxExtent, style, styleBaseUrls, tileSourcesUrls} = this;

        this.callParent();

        this.map = new maplibregl.Map({
            container: this.item.getEl().dom.querySelector('.sa-vector-map-export-thematic-map-container'),
            interactive: false,
            maxBounds: maxExtent.toLngLatBounds(),
            preserveDrawingBuffer: true,
            style,
            trackResize: false,
            transformRequest: SA.VectorMapThematicMapRequestTransformFunction.get(styleBaseUrls)
        });

        this.attribution = this.item.getEl().dom.appendChild(SA.Svg.wrap({
            backgroundColor: 'rgba(255, 255, 255, 0.5)',
            class: 'sa-vector-map-export-thematic-map-attribution',
            margin: 2,

            content: {
                type: 'text',
                content: attributionText,
                dominantBaseline: 'hanging',
                fill: 'rgba(0, 0, 0, 0.75)',

                style: {
                    fontFamily: 'Verdana, sans-serif',
                    fontSize: '12px',
                    fontVariantLigatures: 'no-common-ligatures'
                }
            }
        }));

        this.loading = false;

        this.map.on('data', this.onMapData.bind(this));
        this.map.on('dataabort', this.onMapData.bind(this));
        this.map.on('dataloading', this.onMapData.bind(this));
        this.map.on('error', this.onMapError.bind(this));

        this.map.once('load', () => {
            Object.entries(geoJsonSourcesData).forEach(([sourceId, data]) => this.map.getSource(sourceId).setData(data));
            Object.entries(tileSourcesUrls).forEach(([sourceId, tiles]) => this.map.getSource(sourceId).setTiles(tiles));

            Object.entries(layersProperties).forEach(([layerId, properties]) => SA.VectorMapLayerProperties.apply(this.map, layerId, properties));
        });
    },

    destroy() {
        this.map?.remove();

        this.callParent();
    },

    isLoading() {
        return this.loading;
    },

    onHttpError(callback, scope) {
        this.on('httperror', callback, scope);
    },

    onLoadingChange(callback, scope) {
        this.on('change:loading', callback, scope);
    },

    onMapData() {
        var loading = !this.map.isStyleLoaded();

        if (loading !== this.loading) {
            this.loading = loading;

            this.fireEvent('change:loading');
        }
    },

    async onMapError({error}) {
        if (!(error instanceof maplibregl.AJAXError)) {
            console.error(error);

            return;
        }

        var text = await error.body.text();

        this.fireEvent('httperror', JSON.parse(text));

        this.onMapData();
    },

    setGeoJsonSourcesData(geoJsonSourcesData) {
        var style = this.map.getStyle();

        Object.entries(geoJsonSourcesData)
            .filter(([sourceId, data]) => SA.Json.differ(data, style.sources[sourceId].data))
            .forEach(([sourceId, data]) => this.map.getSource(sourceId).setData(data));
    },

    setParams({extent, height, width}) {
        this.setSize(width, height);

        this.item.setHeight(this.item.getEl().dom.offsetWidth / extent.getAspectRatio());

        this.map.setPixelRatio(Math.max(this.getScale(), devicePixelRatio));
        this.map.resize();
        this.map.fitBounds(extent.toLngLatBounds(), {animate: false});
    }
});